import './App.css';
import MainRoute from './routes/mainRoute';
import { Provider } from "react-redux";
import { store } from "./redux/store";
import AOS from "aos";
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      offset: 100,
    });
  }, []);
  return (
    <Provider store={store}>
      <div className="App">
        <MainRoute />
      </div>
    </Provider>
  );
}

export default App;
